<div class="avatar" (click)="goToProfile.emit()"> 
  {{ userInitials }} 
</div>